exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_object-gops.js
// module id = 508
// module chunks = 1